import React from 'react';

import { useQuery, useMutation } from '@tanstack/react-query';

import FormContainer from '../../../FormContainer';
import Table from '../../../../Table';
import AddButton from '../../../../AddButton';

import VendorService from '../../../../../services/VendorService';
import useContactForm from '../../../../../forms/vendor/contact';
import VendorContactService from '../../../../../services/VendorContactService';
import { useUiContext } from '../../../../../context/UiContext';
import useQueryParam from '../../../../../hooks/useQueryParam';

export default function Contacts({ vendorId }) {
  const { data: contacts, refetch } = useQuery({
    queryKey: ['vendorContacts', vendorId],
    queryFn: () => VendorService.getVendorContacts(vendorId),
    enabled: !!vendorId,
  });

  const { showToast, showDialogModal } = useUiContext();

  const { addQueryParam, getQueryParam, removeQueryParam } =
    useQueryParam('addNew');
  const isAddNew = getQueryParam();

  const { mutate: createContact, isPending } = useMutation({
    mutationFn: (formValues) =>
      VendorContactService.createVendorContact({
        formValues,
        vendorId,
      }),
    onSuccess: () => {
      refetch();
      removeQueryParam();
      showToast({ type: 'success', text: 'Contact created successfully' });
    },
    onError: (error) => {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const cols = [
    {
      title: 'Name',
      keys: ['name'],
      link: (row) => `/vendors/${vendorId}/contacts/${row.id}?tab=Contact`,
    },
    {
      title: 'Phone',
      keys: ['phone'],
    },
    {
      title: 'Email',
      keys: ['email'],
    },
    {
      title: 'City',
      keys: ['city'],
    },
    {
      title: 'Actions',
      type: 'delete',
      onClick: async (row) => {
        showDialogModal({
          type: 'danger',
          title: 'Are you sure want to remove this contact?',
          onConfirm: async () => {
            try {
              await VendorContactService.deleteVendorContact(row.id);
              refetch();
              showToast({
                text: 'Contact deleted successfully',
                type: 'success',
              });
            } catch (error) {
              console.log(error);
              showToast({
                text: error?.response?.data?.message || 'Something went wrong',
                type: 'error',
              });
            }
          },
        });
      },
    },
  ];

  const form = useContactForm(createContact);

  return (
    <div>
      <div className="mb-4 flex justify-end">
        <AddButton
          onClick={addQueryParam}
          style={{
            visibility: isAddNew ? 'hidden' : 'visible',
          }}
        >
          Create Contact
        </AddButton>
      </div>
      <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
        {isAddNew && (
          <div className="mb-10">
            <FormContainer
              groupSizeOffset={10}
              isVisible={false}
              form={form}
              noBillComId
              isSubmitting={isPending}
            />
          </div>
        )}
        {!isAddNew && (
          <Table cols={cols} rows={contacts} title="Contacts" minHeight={565} />
        )}
      </div>
    </div>
  );
}
